import React, { useEffect } from 'react';
import './ModalComponent.css';
import { Link } from 'react-router-dom';

const ModalComponent = ({ showModal, closeModal, imgPrev, titleModal, linkVideo, videoModal }) => {
    useEffect(() => {
        if (showModal) {
            document.body.classList.add('modal-open');
        } else {
            document.body.classList.remove('modal-open');
        }
    }, [showModal]);

    return (
        <div className="modal-overlay" style={{ display: showModal ? 'block' : 'none' }}>
            {/* pc modal style */}
            <div className="d-none d-md-block d-lg-block d-xl-block modal-1 w-60">
                <h2 className='d-none d-md-block d-lg-block d-xl-block text-start text-white font-17'>
                    {titleModal}
                </h2>
                <h2 className='d-block d-md-none d-lg-none d-xl-none text-start text-white font-13'>
                    {titleModal}
                </h2>
                <div className="modal-view w-100">
                    <div className="modal-view-content">
                        <span className="close" onClick={closeModal}>&times;</span>
                        {/* Aquí colocamos el video o imagen */}
                        {videoModal && videoModal !== null ? (
                            <>
                                {console.log(videoModal)}
                                <video src={videoModal} controls className="video-fluid-modal" autoPlay aut></video>
                            </>
                        ) : (
                            <img src={imgPrev} alt="Descripción de la imagen" className="img-fluid-modal" />
                        )}
                    </div>
                </div>
                <Link to={linkVideo || "/chapters"} onClick={() => {
                    closeModal();
                    document.body.classList.remove('modal-open');
                }}>
                    <p className='fw-bold mt-2 text-white cursor-pointer'>Ver más</p>
                </Link>
            </div>


            {/* mobile modal style */}

            <div className="d-block d-md-none d-lg-none d-xl-none modal-1 w-100">
                <h2 className='d-none d-md-block d-lg-block d-xl-block text-start text-white font-17'>
                    {titleModal}
                </h2>
                <h2 className='d-block d-md-none d-lg-none d-xl-none text-start text-white font-13'>
                    {titleModal}
                </h2>
                <div className="modal-view w-100">
                    <div className="modal-view-content">
                        {/* Aquí colocamos el video o imagen */}
                        <span className="close" onClick={closeModal}>&times;</span>
                        {videoModal && videoModal !== null ? (
                            <>
                                <video
                                    src={videoModal}
                                    controls
                                    className="video-fluid-modal"
                                    autoFocus
                                    loop
                                    onEnded={(e) => e.target.play()}
                                ></video>
                            </>
                        ) : (
                            <img src={imgPrev} alt="Descripción de la imagen" className="img-fluid-modal" />
                        )}
                    </div>
                </div>
                <Link to={linkVideo || "/chapters"} onClick={() => {
                    closeModal();
                    document.body.classList.remove('modal-open');
                }}>
                    <p className='fw-bold mt-2 text-white cursor-pointer'>Ver más</p>
                </Link>
            </div>
        </div>
    );
};

export default ModalComponent;